<template>
  <v-app style="background-color: lightgray;">
    <AutoLogout></AutoLogout>
    <v-toolbar class="col-xs-12" app height="45">
      <div>
        <a @click="backToPrevPage()">
          <v-icon style="font-size:30px;padding-left:2.5px;padding-top:2px;">arrow_back</v-icon>
        </a>
      </div>
      <div>
        <h3 style="margin:0px;margin-left:20px;">My Purchases</h3>
      </div>
    </v-toolbar>
    <!-- <v-layout style="margin-top:45px;"> -->
    <v-container style="margin-top:45px;">
      <div v-if="emptyPurchHistory == false">
        <div class="col-xs-12" style="margin-bottom: 30px;">
          <a
            v-for="PurchHistory in ListOfPurchHistory"
            :key="PurchHistory.ID"
            class="list-group-item clearfix border"
            style="margin:10px;"
            @click="viewOrder(PurchHistory.oa)"
          >
            <div class="col-xs-12 pull-left" style="padding: 0px;">
              <h5 class="list-group-item-text">Order ID: {{ PurchHistory.oa }}</h5>
              <h5 class="list-group-item-text">{{ PurchHistory.mx | currentDate(PurchHistory.mx) }}</h5>
              <h4
                class="list-group-item-text"
                style="float:right; font-size:25px;color:red;"
              >RM {{ PurchHistory.oj | currency(PurchHistory.oj)}}</h4>
            </div>
          </a>
        </div>
      </div>

      <div v-if="emptyPurchHistory">
        <div>
          <h2 style="margin:30px">No Purchase History Record</h2>
        </div>
      </div>
    </v-container>
    <!-- </v-layout> -->
    <VersionDialog v-if="versionError"></VersionDialog>
  </v-app>
</template>

<script>
// import $ from 'jquery'
import JS from './JsonService'
import Vue from 'vue'
import globalVar from './GlobalVar.js'
import VersionDialog from '../src/VersionNotMatchDialog'
import VueSession from 'vue-session'
import AutoLogout from './AutoLogout'
Vue.use(VueSession, { persist: true })
export default {
  components: {
    AutoLogout,
    VersionDialog
  },
  filters: {
    currency(amount) {
      const amt = Number(amount)
      return amt.toFixed(2)
    },
    currentDate(date) {
      // console.log(date)
      const date1 = new Date(date).toString().substring(0, 24)
      // console.log(date1)
      return date1
    }
  },
  data() {
    return {
      mCode: '',
      clientId: '',
      emptyPurchHistory: true,
      ListOfPurchHistory: [],
      versionError: false
    }
  },
  created() {
    sessionStorage.setItem('needBackPrevPosition', false)
    this.emptyPurchHistory = true
    //Check login
    if (sessionStorage.getItem('successLogin')) {
      const value = sessionStorage.getItem('successLogin')
      var status = JSON.parse(value)
      console.log(status)
      if (status.clientId) {
        this.clientId = status.clientId
        console.log('client Id: ', this.clientId)
      } else {
        sessionStorage.clear()
        if (globalVar.mode == 'normal') {
          this.$router.replace('/')
        } else if (globalVar.mode == 'lite') {
          var mchCd = sessionStorage.getItem('paramMchdCode')
          this.$router.replace({ name: 'Search', params: { mchdCode: mchCd } })
        }
      }
    }

    const key = 'searchedInfo'
    if (sessionStorage.getItem(key)) {
      const value = sessionStorage.getItem(key)
      // console.log(value)
      this.searchedData = JSON.parse(value)
      // console.log(this.searchedData)
      this.mCode = this.searchedData.kp
    }

    //get Purchase History
    this.getPurchaseHistory()
  },
  destroyed() {
    console.log('destroy')
  },
  methods: {
    getPurchaseHistory() {
      this.versionError = false
      var version = sessionStorage.getItem('version')
      const url = 'Order/PurchaseHistory'
      const parameter = {
        av: version,
        kp: this.mCode,
        m: this.clientId
      }
      console.log('parameter: ', parameter)

      JS.request(url, parameter)
        .then(response => {
          console.log('data : ', response.data)
          if (
            response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
            response.data == 'Version Not Match'
          ) {
            this.versionError = true
          } else {
            this.versionError = false
            if (response.data.ListOfTrnHdr.length > 0) {
              this.emptyPurchHistory = false
              this.ListOfPurchHistory = response.data.ListOfTrnHdr
            } else {
              this.emptyPurchHistory = true
            }
          }
        })
        .catch(error => {
          this.versionError = false
          console.log(error)
        })
    },
    viewOrder(eorderId) {
      console.log(eorderId)
      if (eorderId != '') {
        sessionStorage.setItem('fromPHistory', 'Yes')
        if (globalVar.mode == 'normal') {
          this.$router.replace({
            name: 'viewOrder',
            params: { token: eorderId }
          })
        } else if (globalVar.mode == 'lite') {
          var mchCd = sessionStorage.getItem('paramMchdCode')
          this.$router.replace({
            name: 'viewOrder',
            params: { mchdCode: mchCd, token: eorderId }
          })
        }
      }
    },
    backToPrevPage() {
      const value = sessionStorage.getItem('viewPurchaseHistory')
      console.log(value)
      sessionStorage.setItem('viewPurchaseHistory', '')
      if (value == 'fromSearch') {
        sessionStorage.setItem('afterViewPH', '')
        if (globalVar.mode == 'normal') {
          this.$router.replace('/')
        } else if (globalVar.mode == 'lite') {
          var mchCd3 = sessionStorage.getItem('paramMchdCode')
          this.$router.replace({ name: 'Search', params: { mchdCode: mchCd3 } })
        }
      } else if (value == 'fromMainList') {
        sessionStorage.setItem('afterViewPH', '')
        if (globalVar.mode == 'normal') {
          this.$router.replace('/mainlist')
        } else if (globalVar.mode == 'lite') {
          var mchCd = sessionStorage.getItem('paramMchdCode')
          this.$router.replace({
            name: 'MainList',
            params: { mchdCode: mchCd }
          })
        }
      } else if (value == 'fromShoppingCart') {
        sessionStorage.setItem('afterViewPH', 'fromShoppingCart')
        if (globalVar.mode == 'normal') {
          this.$router.replace('/shopping-cart')
        } else if (globalVar.mode == 'lite') {
          var mchCd2 = sessionStorage.getItem('paramMchdCode')
          this.$router.replace({
            name: 'ShoppCart',
            params: { mchdCode: mchCd2 }
          })
        }
      } else {
        sessionStorage.setItem('afterViewPH', '')
        if (globalVar.mode == 'normal') {
          this.$router.go('/')
        } else if (globalVar.mode == 'lite') {
          var mchCd4 = sessionStorage.getItem('paramMchdCode')
          this.$router.go({ name: 'Search', params: { mchdCode: mchCd4 } })
        }
      }
      // this.$router.go(-1)
    }
  }
}
</script>

<style>
.border {
  padding: 15px;
  border: 2px solid gainsboro;
  border-radius: 15px;
  width: 90% !important;
}
</style>
